import { Component, Input } from '@angular/core';
import { ThesaurusService } from '@thesaurus-service/thesaurus.service';

@Component({
    selector: 'app-icon-legend',
    templateUrl: './icon-legend.component.html',
    styleUrls: ['./icon-legend.component.scss'],
    standalone: false
})
export class IconLegendComponent {
    @Input() thesaurusId: string = "";
    view: string = "notesOnly";

    constructor(
        private thesaurusService: ThesaurusService
    ){}

    getView(): string {
        if (this.thesaurusId.includes("acta_lexicon_qualifiers") || this.thesaurusId.includes("company") || this.thesaurusId.includes("pqbuscat")) {
            this.view = "noIcon";
        }

        if (this.thesaurusId.includes("medline")) {
            this.view = "notesQualifier";
        }
            
        return this.view;
    }
}